import {
	SET_FORM_BODY_SAVE_STATE,
	CLEAR_FORM_BODY_SAVE_STATE,
	CLEAR_FORM_BODY_SAVE_STATE_BY_BODY_ID,
	CLEAR_FORMBODYDISPLAYDATA
} from '../actiontypes';

export function setFormBodySaveState(bodyId, hasChanges = false, elementName = 'unnamed-input') {
	return {
		type: SET_FORM_BODY_SAVE_STATE,
		bodyId,
		elementName,
		hasChanges
	};
}

export function clearFormBodySaveState() {
	return {
		type: CLEAR_FORM_BODY_SAVE_STATE
	};
}

export function clearFormBodyDisplayData() {
	return {
		type: CLEAR_FORMBODYDISPLAYDATA
	};
}

export function clearFormBodySaveStateById(bodyId) {
	return {
		type: CLEAR_FORM_BODY_SAVE_STATE_BY_BODY_ID,
		bodyId
	};
}
